// Whipping egg whites into meringue in a bowl. The whisk beats air in only
// while it moves through the whites, in proportion to how far it travels,
// more slowly as the foam fills up. The whites go from clear liquid to
// foam, to soft peaks, to stiff peaks, swelling as they take in air. Lifting
// the whisk pulls up a peak: soft meringue droops over, stiff stands up.
// Turned upside down, stiff meringue stays in the bowl.
const STAGES=[['liquid',0],['foamy',.3],['soft',.6],['stiff',.86]];
export class Meringue{
  constructor({center,radius}){this.center=[...center];this.radius=radius;this.reset();}
  reset(){this.air=0;this.peaks=[];this.last=null;this.stage='liquid';}
  get volume(){return 1+2*this.air**.8;}
  get stiffness(){return Math.max(0,Math.min(1,(this.air-.5)/.4));}
  step(dt,whisk){
    const events=[];
    if(whisk?.inside&&this.last){
      const moved=Math.hypot(whisk.p[0]-this.last[0],whisk.p[2]-this.last[2]);
      this.air=Math.min(1,this.air+moved/this.radius*.02*(1-this.air*.6));
    }
    this.last=whisk?.inside?[...whisk.p]:null;
    const stage=STAGES.filter(([,a])=>this.air>=a).at(-1)[0];
    if(stage!==this.stage){this.stage=stage;events.push(stage);}
    return events;
  }
  // The whisk leaves where it lifted out: a peak if the foam can hold one.
  lift(point){
    if(this.air<.3)return null;
    const s=this.stiffness,peak={x:point[0],z:point[2],height:this.radius*(.12+.28*Math.min(1,this.air)),bend:(1-s)*.9+.05,turn:Math.atan2(point[2]-this.center[2],point[0]-this.center[0])};
    this.peaks.push(peak);if(this.peaks.length>6)this.peaks.shift();return peak;
  }
  flip(){return this.air>=.86?'holds':'falls';}
}
